import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LoginForm } from "./LoginForm";
import { SignupForm } from "./SignupForm";
import { ForgotPasswordDialog } from "./ForgotPasswordDialog";

export const AuthForm = ({ mode = "login" }: { mode?: "login" | "signup" }) => {
  const [showResetDialog, setShowResetDialog] = useState(false);

  return (
    <>
      <Card className="w-full max-w-md mx-auto">
        <CardHeader>
          <CardTitle className="text-2xl font-heading text-center text-[#0aabco]">
            {mode === "login" ? "Welcome Back!" : "Create Your Account"}
          </CardTitle>
        </CardHeader>
        <CardContent>
          {mode === "login" ? (
            <>
              <LoginForm />
              <Button
                type="button"
                variant="link"
                className="w-full text-primary mt-2"
                onClick={() => setShowResetDialog(true)}
              >
                Forgot Password?
              </Button>
            </>
          ) : (
            <SignupForm />
          )}
        </CardContent>
      </Card>

      <ForgotPasswordDialog 
        open={showResetDialog} 
        onOpenChange={setShowResetDialog} 
      />
    </>
  );
};